import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { uploadReset } from "../../redux/Actions/SingleUserActions";
import Storage from "../../utils/storage";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import {
  getDocs,
  getUserStatus,
  getRequiredDocs,
} from "../../redux/Actions/GetDocsActions";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import jwt_decode from "jwt-decode";
import POSRequirement from "./POSRequirement";
import { uploadPosDeviceDocs } from "../../redux/Actions/PosActions";
import UserStatus from "../../components/Certification/UserStatus";
import DocsUpload from "./DocsUpload";
import checkDocs from "../../utils/Functions/CheckCategory";
import assign from "../../utils/Functions/AssignObj";
import UpdateArray from "../../utils/Functions/UpdateArray";
import Spinner from "react-spinner-material";
import { PropTypes } from "prop-types";
import {getCertificationAmount} from "../../redux/Actions/GetDocsActions"

export const DeviceUpload = (props) => {
  const {
    isGetting,
    getDocsList,
    getStatus,
    dashboardData,
    isUploading,
    uploadSuccess,
    uploadDocs,
    uploadedDoc,
    uploadReset,
    docs,
    isFetching,
    getStatusSuccess,
    requiredDocs,
    getRequiredDocs,
    isFetchingRequiredDocs,
    getRequiredDocsSuccess,
    getCertificationAmount
  } = props;
  const history = useHistory();

  let userToken = Storage.get("user-access-token");
  const token = jwt_decode(userToken);
  let userCompanyId = token && token.id;
  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let categoryChoice = user && user.category_id;

  const singlePosApp = props.location.state;

  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      uploadReset();
      const type = "device";
      getRequiredDocs(type);
      getStatus();
    },
    // eslint-disable-next-line
    [getRequiredDocs, getStatus]
  );

  // NOSONAR
  const appStatus =
    dashboardData && dashboardData[1] && dashboardData[1].pos_application;
    // NOSONAR
  const userAppStatus2 = appStatus && appStatus[0] && appStatus[0].status;
  // NOSONAR
  const userAppStatus =
    appStatus && appStatus[0] && appStatus[0].nibss_super_admin_status;
    // NOSONAR
  const userAppId = singlePosApp && singlePosApp.id;
  const appId = (userAppId && uploadedDoc.application_id) || userAppId;

  useEffect(
    () => {
      if (getStatusSuccess) {
        const type = "certification";
        getDocsList(type);
      
      }
    },
    // eslint-disable-next-line
    [getStatusSuccess, getDocsList]
  );

  const categoryDocs =
    requiredDocs &&
    requiredDocs[categoryChoice] &&
    requiredDocs[categoryChoice].documents;

  const uploadedDocs = docs && docs[0] && docs[0].documents;
  const filteredUploadedDocs =
    uploadedDocs &&
    uploadedDocs.filter(
      (item) =>
        item.id === 1 ||
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    );
  const checkingStatus =
    docs &&
    docs.length > 0 &&
    filteredUploadedDocs &&
    filteredUploadedDocs.length > 0;

  checkDocs(categoryDocs, filteredUploadedDocs);

  function handleDataFetch(fileResult) {
    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      let allResult = uploadedDocs;
      setState({
        allResult,
      });
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    } else {
      let allResult = [...state.allResult];
      UpdateArray(allResult, fileResult);
      setState({ allResult });
    }
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult
  };

  const uploadDeviceDocs1 = () => {
    let allFiles = [];
    const data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 21 ||
          item.id === 22 ||
          item.id === 23 ||
          item.id === 24 ||
          item.id === 25 ||
          item.id === 26 ||
          item.id === 38 ||
          item.id === 39
      );
    assign(data, allFiles);
    const files = {
      application_id: userAppId && userAppId.toString(),
      company_id: userCompanyId && userCompanyId.toString(),
      type: "device",
      document: allFiles,
    };
    uploadDocs(files);
  };

  const uploadDeviceDocs2 = () => {
    let allFiles = [];
    const data =
      state.allResult &&
      state.allResult.filter(
        (item) =>
          item.id === 1 ||
          item.id === 21 ||
          item.id === 22 ||
          item.id === 23 ||
          item.id === 24 ||
          item.id === 25 ||
          item.id === 26 ||
          item.id === 38 ||
          item.id === 39
      );
    assign(data, allFiles);
    const files = {
      application_id: userAppId && userAppId.toString(),
      company_id: userCompanyId && userCompanyId.toString(),
      type: "device",
      document: allFiles,
    };
    uploadDocs(files);
  };

  const uploadDeviceDocs = () => {

    if (filteredUploadedDocs && filteredUploadedDocs.length > 0) {
      uploadDeviceDocs1();
    } else {
      uploadDeviceDocs2();
    }
  };

  const disable =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    ).length < 8;

  const disable2 =
    state.allResult &&
    state.allResult.filter(
      (item) =>
        item.id === 1 ||
        item.id === 21 ||
        item.id === 22 ||
        item.id === 23 ||
        item.id === 24 ||
        item.id === 25 ||
        item.id === 26 ||
        item.id === 38 ||
        item.id === 39
    ).length < 9;

  useEffect(
    () => {
      if (uploadSuccess) {
        state.errorMessage = "";
        Alert(true, "success", "Success message", "Upload successful.");
        const appId = (userAppId && uploadedDoc.application_id) || userAppId;
        history.push({
          pathname: "/payment",
          state: {
            id: appId,
            type: "device",
            amount_id: 3,
          },
        });
        setState({
          ...state,
          errorMessage: "",
        });

        getCertificationAmount(3, appId)
      }
    },
    // eslint-disable-next-line
    [uploadSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <UserStatus
          userAppStatus={userAppStatus}
          userAppStatus2={userAppStatus2}
          appStatus={appStatus}
          status={dashboardData}
        />

        <div className="upload-flex">
          <div className="upload-title">
            <h2>POS Device Certification Documents</h2>
            <p>
              The documents we ask for are based on your certification selection
            </p>
            <p>
              (Only pdf, png, jpeg and jpg formats are allowed with a max file
              size of 5MB)
            </p>
          </div>

          <POSRequirement type={"device"} />
        </div>

        {isGetting || isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
            getRequiredDocsSuccess && (
              <DocsUpload
                categoryDocs={categoryDocs}
                upload={uploadDeviceDocs}
                disabled={
                  checkingStatus
                    ? disable === true
                    : disable2 === true || isUploading
                }
                isUploading={isUploading}
                handleDataFetch={handleDataFetch}
                handleRemoval={handleRemoval}
                isFetching={isFetching}
                text={"PROCEED TO PAYMENT"}
              />
            )
          )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.pos.isUploading,
    uploadSuccess: state.pos.uploadSuccess,
    uploadedDoc: state.pos.uploadedDoc,
    docs: state.docs.docs,
    dashboardData: state.docs.status,
    isFetching: state.docs.isFetching,
    isGetting: state.docs.isGetting,
    getStatusSuccess: state.docs.getStatusSuccess,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadDocs: (payload) => dispatch(uploadPosDeviceDocs(payload)),
  getDocsList: (type) => dispatch(getDocs(type)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),
  getCertificationAmount: (type, appId)=> dispatch(getCertificationAmount(type, appId)),
});

DeviceUpload.propTypes = {
  dashboardData: PropTypes.array,
  docs: PropTypes.array,
  getDocsList: PropTypes.func,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatus: PropTypes.func,
  getStatusSuccess: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isGetting: PropTypes.bool,
  isUploading: PropTypes.bool,
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number,
    }),
  }),
  requiredDocs: PropTypes.object,
  uploadDocs: PropTypes.func,
  uploadReset: PropTypes.func,
  uploadSuccess: PropTypes.bool,
  uploadedDoc: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUpload);
